<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <!-- <div @click="rr">{{ isMobile ? "4554" : "0000000" }}</div> -->
    <!-- <Pc-page v-if="!isMobile" /> -->
    <Mobile-page />
  </div>
</template>

<script setup>
  import {
    ref,
    computed
  } from "vue";
  import PcPage from "../components/pcPage.vue";
  import MobilePage from "../components/mobilePage.vue";
  // @ is an alias to /src
  // import HelloWorld from "@/components/HelloWorld.vue";

  // export default {
  //   name: "HomeView",
  //   components: {
  //     HelloWorld,
  //   },
  // };

  const isMobile = computed(() => {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  });

  const rr = () => {
    console.log("1235");
  };
</script>
<style lang="less" scoped>
  .home {
    max-width: 500px;
    margin: 0 auto;
  }
</style>
